import React from 'react';
import { RocketIcon, BuildingIcon, UsersIcon, ZapIcon } from 'lucide-react';
import { FadeUp } from './ui/FadeUp';
export function WhoItsForSection() {
  const audiences = [{
    icon: RocketIcon,
    text: 'Startups scaling past 10–20 employees'
  }, {
    icon: BuildingIcon,
    text: 'Companies without a full HR department'
  }, {
    icon: UsersIcon,
    text: 'Founders who need operational HR support'
  }, {
    icon: ZapIcon,
    text: 'Teams preparing for rapid hiring or growth'
  }];
  return <section className="py-28 bg-white" data-id="element-365">
      <div className="max-w-[1240px] mx-auto px-8" data-id="element-366">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-367">
          <FadeUp data-id="element-368">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6" data-id="element-369">
              Designed for the messy middle of growth
            </h2>
            <p className="text-lg text-gray-600 mb-8" data-id="element-370">
              SparkHR is designed for companies that are too big to wing HR but
              not ready for a full internal department.
            </p>
          </FadeUp>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6" data-id="element-371">
            {audiences.map((item, index) => <FadeUp key={index} delay={index * 0.1} data-id="element-372">
                <div className="bg-white p-6 rounded-xl border border-[#eee] shadow-[0_10px_30px_rgba(0,0,0,0.05)] h-full flex flex-col gap-4" data-id="element-373">
                  <div className="w-10 h-10 rounded-xl bg-section-lavender flex items-center justify-center text-purple-400" data-id="element-374">
                    <item.icon className="w-5 h-5" data-id="element-375" />
                  </div>
                  <p className="text-gray-800 font-medium" data-id="element-376">{item.text}</p>
                </div>
              </FadeUp>)}
          </div>
        </div>
      </div>
    </section>;
}